import { formatInTimeZone } from 'date-fns-tz'

import { useDateStore } from '@/components/DateInput'
import { Disruption } from '@/types/disruptions'
import { useNotification } from '@/ui/Notification'

export const useShareDisruption = (disruption: Disruption) => {
    const { showNotification } = useNotification()
    const { date } = useDateStore()

    const handleShareDisruption = () => {
        const url = new URL(`${window.location.origin}/disruptions/shared`)
        url.searchParams.set('id', disruption.id.toString())
        url.searchParams.set('date', formatInTimeZone(date, 'UTC', 'yyyy-MM-dd'))

        if (disruption.routes && disruption.routes.length > 0) {
            url.searchParams.set('route', disruption.routes[0].route)
        }

        navigator.clipboard
            .writeText(url.toString())
            .then(() => {
                showNotification({
                    message: 'Disruption link copied to clipboard',
                })
            })
            .catch(() => {
                showNotification({
                    message: 'Failed to copy link to clipboard',
                })
            })
    }

    return { handleShareDisruption }
}
